import { render, staticRenderFns } from "./FacebookInfo.vue?vue&type=template&id=bb9e1572&"
import script from "./FacebookInfo.vue?vue&type=script&lang=js&"
export * from "./FacebookInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports